/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ec39a69a86d148573259e2d67c3f9ebcfadbc8fe";
